import React from 'react';

type TFn = (key: string, fallback: string, params?: Record<string, string | number>) => string;

interface UpdateSuccessScreenProps {
  nombre: string;
  t: TFn;
}

export const UpdateSuccessScreen: React.FC<UpdateSuccessScreenProps> = ({ nombre, t }) => (
  <div className="min-h-screen bg-[#F7F4EE] flex items-center justify-center px-4">
    <div className="bg-white rounded-2xl p-8 max-w-sm w-full text-center shadow-sm space-y-5">
      <span className="text-5xl block">✅</span>
      <h2 className="font-fredoka text-2xl font-bold text-[#1a1a1a]">
        {t('step13c.update_success_title', '¡Plan actualizado!')}
      </h2>
      <p className="font-poppins text-sm text-black/60 leading-relaxed">
        {t(
          'step13c.update_success_body',
          'El plan de {nombre} se ha actualizado correctamente. Los cambios se aplicarán en la próxima renovación.',
          { nombre },
        )}
      </p>
      <a
        href="/mi-cuenta"
        className="block w-full py-3 rounded-xl font-fredoka text-base font-bold bg-[#008BBC] text-white hover:bg-[#007aa8] transition-colors shadow-md"
      >
        {t('step13c.update_success_cta', 'Volver a Mi Cuenta')}
      </a>
    </div>
  </div>
);

interface UpdateDegradedScreenProps {
  nombre: string;
  t: TFn;
}

export const UpdateDegradedScreen: React.FC<UpdateDegradedScreenProps> = ({ nombre, t }) => (
  <div className="min-h-screen bg-[#F7F4EE] flex items-center justify-center px-4">
    <div className="bg-white rounded-2xl p-8 max-w-sm w-full text-center shadow-sm space-y-5">
      <span className="text-5xl block">⚠️</span>
      <h2 className="font-fredoka text-2xl font-bold text-[#1a1a1a]">
        {t('step13c.update_degraded_title', 'Perfil actualizado')}
      </h2>
      <p className="font-poppins text-sm text-black/60 leading-relaxed">
        {t(
          'step13c.update_degraded_body',
          'Tu perfil ha sido actualizado. Los cambios en las recetas no se pudieron aplicar automáticamente — contacta con soporte para confirmarlos.',
          { nombre },
        )}
      </p>
      <a
        href="/mi-cuenta"
        className="block w-full py-3 rounded-xl font-fredoka text-base font-bold bg-[#008BBC] text-white hover:bg-[#007aa8] transition-colors shadow-md"
      >
        {t('step13c.update_success_cta', 'Volver a Mi Cuenta')}
      </a>
    </div>
  </div>
);
